import * as React from 'react'
import axios from 'axios'
import { refusalMessage } from './checkoutErrors'

// Mode B: the prorated amount for the selected plan, previewed as soon as the
// row changes so the left column is never out of date. Answers are tagged with
// a sequence number so a slow reply can never overwrite a newer one.
export function usePlanChangePreview({ enabled, selectedPlan, currentPlanId }) {
    const [state, setState] = React.useState({
        preview: null,
        status: 'idle',
        error: null,
    })
    const sequenceRef = React.useRef(0)
    // Bumped to price the same plan again, e.g. after a card was added.
    const [revision, setRevision] = React.useState(0)
    const reprice = React.useCallback(
        () => setRevision(current => current + 1),
        []
    )

    React.useEffect(() => {
        if (!enabled || !selectedPlan) return undefined
        if (selectedPlan.planId === currentPlanId) {
            setState({ preview: null, status: 'idle', error: null })
            return undefined
        }
        const sequence = ++sequenceRef.current
        setState(current => ({ ...current, status: 'loading', error: null }))
        const timer = setTimeout(() => {
            axios
                .post('/billing/plan/change?preview=1', {
                    plan: selectedPlan.planId,
                })
                .then(response => {
                    if (sequence !== sequenceRef.current) return
                    setState({
                        preview: response.data,
                        status: 'ready',
                        error: null,
                    })
                })
                .catch(previewError => {
                    if (sequence !== sequenceRef.current) return
                    setState({
                        preview: null,
                        status: 'failed',
                        error: refusalMessage(
                            previewError,
                            'Could not price that plan change.'
                        ),
                    })
                })
        }, 250)
        return () => clearTimeout(timer)
    }, [enabled, selectedPlan, currentPlanId, revision])

    return { ...state, reprice }
}
